export class OceanTotalAmountRequest {
    destinationId: number;
    linerId: number;
    countryId: number;
    total:string;

}